import { dateLocale, plural, t } from '../../lib/i18n';

/** Menü ekranlarının ortak sınıfları — hepsi aynı kart ve başlık dilini kullanıyor. */
export function cardClass(isDarkMode: boolean): string {
  return isDarkMode ? 'bg-[#16161A] border-[#222228]' : 'bg-white border-neutral-200 shadow-2xs';
}

export function inputClass(isDarkMode: boolean): string {
  return isDarkMode
    ? 'bg-[#27272B] border-[#424248] text-[#F0EEE6] placeholder:text-neutral-600 focus:border-[#3AC8E0]'
    : 'bg-neutral-50 border-neutral-300 text-neutral-900 placeholder:text-neutral-400 focus:border-[#3AC8E0]';
}

export const sectionTitle = 'text-[11px] font-bold uppercase tracking-[0.09em] text-neutral-500 px-1';

export function pageTitle(isDarkMode: boolean): string {
  return `text-2xl font-bold tracking-tight ${isDarkMode ? 'text-[#F0EEE6]' : 'text-neutral-900'}`;
}

export const primaryButton =
  'flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-[#1DA4BA] hover:bg-[#3AC8E0] disabled:opacity-50 text-[#F0EEE6] text-xs font-semibold transition-colors shadow-xs';

export function secondaryButton(isDarkMode: boolean): string {
  return `flex items-center gap-1.5 px-3 py-1.5 rounded-xl border text-xs font-semibold transition-all disabled:opacity-50 ${
    isDarkMode
      ? 'bg-[#18181F] border-[#2A2A34] text-neutral-200 hover:text-[#F0EEE6] hover:border-neutral-500'
      : 'bg-white border-neutral-200 text-neutral-800 hover:border-neutral-400'
  }`;
}

/** "3 gün önce" gibi göreli tarih. */
export function formatRelativeDate(iso: string | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const days = Math.floor((Date.now() - date.getTime()) / (24 * 60 * 60 * 1000));
  if (days <= 0) return t('bugün', 'today');
  if (days === 1) return t('dün', 'yesterday');
  if (days < 7) return t(`${days} gün önce`, `${days} days ago`);
  const weeks = Math.floor(days / 7);
  if (days < 30) return t(`${weeks} hafta önce`, `${plural(weeks, 'week', 'weeks')} ago`);
  return date.toLocaleDateString(dateLocale(), { day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(dateLocale(), { day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatClock(iso: string): string {
  return new Date(iso).toLocaleTimeString(dateLocale(), { hour: '2-digit', minute: '2-digit' });
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toLocaleUpperCase('tr') || '?';
}
